import { html } from "lit-element";

export const colorTheme = html` 
<style>
:host {

    --primary-color: #4285f4;
    --primary-color-variant1: #ffffff;
    --primary-color-variant2: #d2d2d2;
    --primary-color-variant3: #eef0f3;
    --secondary-color: #264475;
    --secondary-color-variant1: #697384;
}
</style>
`;
